import { render, staticRenderFns } from "./eg_additional_collapse.vue?vue&type=template&id=16f2336d&scoped=true&"
import script from "./eg_additional_collapse.vue?vue&type=script&lang=js&"
export * from "./eg_additional_collapse.vue?vue&type=script&lang=js&"
import style0 from "./eg_additional_collapse.vue?vue&type=style&index=0&id=16f2336d&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16f2336d",
  null
  
)

export default component.exports